/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import {
  Alert,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Grid,
  IconButton,
  Link,
  Paper as MuiPaper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { Add as AddIcon, Edit } from "@mui/icons-material";
import { spacing } from "@mui/system";
import { withStyles } from "@mui/styles";
import axios from "../../CustomAxios";
import { connect } from "react-redux";
import Loading from "../components/Loading";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const StyledTableContainer = withStyles((theme) => ({
  root: {
    // width: "max-content",
  },
}))(TableContainer);

const Spacer = styled.div`
  flex: 1 1 100%;
`;

const ToolbarTitle = styled.div`
  min-width: 150px;
`;

function createData(id, name, description, is_deleted) {
  return {
    id,
    name,
    description,
    is_deleted,
  };
}

const headCells = [
  { id: "id", alignment: "left", label: "Sr No." },
  { id: "name", alignment: "left", label: "Name" },
  { id: "description", alignment: "left", label: "Description" },
];

const EnhancedTableHead = (props) => {
  const { edit } = props;
  const [heads, setHeads] = useState(headCells);
  useEffect(() => {
    if (edit) {
      setHeads((prev) => [
        ...prev,
        { id: "edit", alignment: "center", label: "Edit" },
      ]);
    }
  }, []);

  return (
    <TableHead>
      <TableRow>
        {heads.map((headCell) => (
          <TableCell
            // style={{ width: 100 }}
            key={headCell.id}
            align={headCell.alignment}
            padding={headCell.disablePadding ? "none" : "normal"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const EnhancedTableToolbar = (props) => {
  // Here was 'let'
  const navigate = useNavigate();
  return (
    <Toolbar>
      <ToolbarTitle>
        <Typography variant="h6" id="tableTitle">
          Brands
        </Typography>
      </ToolbarTitle>
      <Spacer />
      <Tooltip title="Create Brand">
        <IconButton size="large">
          <AddIcon onClick={() => navigate("/dashboard/inventory/brand")} />
        </IconButton>
      </Tooltip>
    </Toolbar>
  );
};

const getBrands = async (authData, setLoader, setRows) => {
  try {
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${authData?.type}/plate_inventory/brand`,
      config
    );
    const brands = data.data;
    let rows = [];
    brands.map((brand) => {
      rows.push(
        createData(
          brand._id,
          brand.name,
          brand.description,
          brand?.is_deleted || false
        )
      );
    });
    setRows(rows);
    setLoader(false);
  } catch (e) {
    console.log(e);
  }
  setLoader(false);
};

function EnhancedTable({ rows, edit }) {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("customer");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const navigate = useNavigate();
  const location = useLocation();
  // eslint-disable-next-line no-unused-vars
  const [message, setMessage] = useState(location?.state?.message);
  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  useEffect(() => {
    if (location?.state?.success) {
      snackRef.current.click();
      navigate(location.pathname, { replace: true });
    }
  }, [location?.state]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <div>
      <Button
        ref={snackRef}
        style={{ display: "none" }}
        onClick={handleClick({ vertical: "top", horizontal: "center" })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        <Alert mt={2} mb={4} severity="success">
          {message}
        </Alert>
      </Snackbar>
      <Paper>
        <EnhancedTableToolbar numSelected={selected.length} />
        <StyledTableContainer>
          <Table size={"small"}>
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
              edit={edit}
            />
            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.id);

                  return (
                    <TableRow
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={`${row.id}-${index}`}
                      selected={isItemSelected}
                    >
                      <TableCell align="left">
                        {" "}
                        {page * rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell align="left">{row.name}</TableCell>
                      <TableCell align="left">{row.description}</TableCell>
                      {edit ? (
                        <TableCell align="center">
                          <Edit
                            style={{ cursor: "pointer", color: "red" }}
                            onClick={() =>
                              navigate(`/dashboard/inventory/update-brand`, {
                                state: {
                                  id: row.id,
                                  name: row.name,
                                  description: row.description,
                                  is_deleted: row.is_deleted,
                                },
                              })
                            }
                          />
                        </TableCell>
                      ) : null}
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={8} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </StyledTableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}

function ViewBrands({ auths }) {
  const token = JSON.parse(localStorage.getItem("AuthData"));
  const [editPermission, setEditPermission] = useState(false);
  const [loader, setLoader] = useState(true);
  const [rows, setRows] = useState([]);
  useEffect(async () => {
    getBrands(token, setLoader, setRows);
    if (
      auths?.user?.role?.permissions.includes("edit_brand") ||
      token?.type === "super_admin"
    ) {
      setEditPermission(true);
    }
  }, []);
  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              BRANDS
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Typography>View Brands</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <EnhancedTable edit={editPermission} rows={rows} />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}
const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(ViewBrands);
